module.exports = __webpack_public_path__ + "img/img14.5d3c0906.svg";